import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const intitialState = {
  elevators: [],
  buildingElevators: [],
  entranceElevators: [],
  elevatorById: null,
  elevatorsPage: 1,
  elevatorsTotalPages: 1,
  buildingElevatorsPage: 1,
  buildingElevatorsTotalPages: 1,
  elevatorConfigurations: null,
  elevatorsLoading: false,
  elevatorsError: '',
  allElevators: [],
  allElevatorsLoading: false,
  allElevatorsError: '',
  inactiveElevators: [],
  inactiveElevatorsLoading: false,
  inactiveElevatorsError: '',
  inactiveElevatorsPage: 1,
  inactiveElevatorsTotalPages: 1,
};

const elevatorsReducer = (state = intitialState, action) => {
  switch (action.type) {
    case AC.GET_ELEVATORS_REQUEST:
    case AC.GET_BUILDING_ELEVATORS_REQUEST:
    case AC.GET_ENTRANCE_ELEVATORS_REQUEST:
    case AC.GET_ELEVATOR_DETAILS_REQUEST:
    case AC.ADD_ELEVATOR_REQUEST:
    case AC.EDIT_ELEVATOR_REQUEST:
    case AC.DELETE_ELEVATOR_REQUEST:
    case AC.GET_ELEVATOR_CONGIFURATIONS_REQUEST:
    case AC.CONFIGURE_ELEVATOR_REQUEST:
      return updateObject(state, {elevatorsLoading: true, elevatorsError: ''});
    case AC.GET_ELEVATORS_SUCCEED:
      return updateObject(state, {
        elevators: action.payload.data,
        elevatorsPage: action.payload.page,
        elevatorsTotalPages: action.payload.totalPages,
        elevatorsLoading: false,
      });
    case AC.GET_BUILDING_ELEVATORS_SUCCEED:
      return updateObject(state, {
        buildingElevators: action.payload,
        elevatorsLoading: false,
      });
    case AC.GET_ENTRANCE_ELEVATORS_SUCCEED:
      return updateObject(state, {
        entranceElevators: action.payload,
        elevatorsLoading: false,
      });
    case AC.GET_ELEVATOR_DETAILS_SUCCEED:
      return updateObject(state, {
        elevatorById: action.payload,
        elevatorsLoading: false,
      });
    case AC.GET_ELEVATOR_CONGIFURATIONS_SUCCEED:
      return updateObject(state, {
        elevatorConfigurations: action.payload,
        elevatorsLoading: false,
      });
      case AC.GET_ALL_ELEVATORS_REQUEST:
        return updateObject(state, {allElevatorsLoading: true, allElevatorsError: ''});
      
      case AC.GET_ALL_ELEVATORS_SUCCEED:
        return updateObject(state, {
          allElevators: action.payload,
          allElevatorsLoading: false,
        });
      
      case AC.GET_ALL_ELEVATORS_FAILED:
        return updateObject(state, {
          allElevatorsError: action.payload,
          allElevatorsLoading: false,
        });

      case AC.GET_INACTIVE_ELEVATORS_REQUEST:
        return updateObject(state, {inactiveElevatorsLoading: true, inactiveElevatorsError: ''});

      case AC.GET_INACTIVE_ELEVATORS_SUCCEED:
        return updateObject(state, {
          inactiveElevators: action.payload.data,
          inactiveElevatorsPage: action.payload.page,
          inactiveElevatorsTotalPages: action.payload.totalPages,
          inactiveElevatorsLoading: false,
        });

      case AC.GET_INACTIVE_ELEVATORS_FAILED:
        return updateObject(state, {
          inactiveElevatorsError: action.payload,
          inactiveElevatorsLoading: false,
        });

    case AC.GET_ELEVATORS_FAILED:
    case AC.GET_BUILDING_ELEVATORS_FAILED:
    case AC.GET_ELEVATOR_DETAILS_FAILED:
    case AC.ADD_ELEVATOR_FAILED:
    case AC.EDIT_ELEVATOR_FAILED:
    case AC.DELETE_ELEVATOR_FAILED:
    case AC.CONFIGURE_ELEVATOR_FAILED:
    case AC.GET_ELEVATOR_CONGIFURATIONS_FAILED:
      return updateObject(state, {
        elevatorsError: action.payload,
        elevatorsLoading: false,
      });
    default:
      return state;
  }
};

export default elevatorsReducer;
